import React, { useEffect, useState } from 'react';
import { Row, Col, Table, Dropdown, Menu, Image, message, Avatar } from 'antd';
import { EllipsisOutlined, SearchOutlined } from '@ant-design/icons';

import { FullScreenModal } from '@styles/globals';
import { useBrand } from '@hooks/BrandContext';
import ClassificationForm from '@components/ClassificationForm';
import DualForm from '@components/DualForm';
import Text from 'antd/lib/typography/Text';
import TableFilters from '@components/TableFilters';
import { Brand } from '@models/Brand';

const CLASSIFICATION_TYPE_PRODUCT = 'PRODUCT';
const CLASSIFICATION_TYPE_SALES_REGION = 'SALES_REGION';

const BrandsContent: React.FC = () => {
  const [actualBrandId, setActualBrandId] = useState<number | null>(null);
  const [productClassifications, setProductClassifications] = useState<any[]>([]);
  const [salesRegionsClassifications, setSalesRegionsClassifications] = useState<any[]>([]);

  const [modalProductClassificationIsVisible, setModalProductClassificationIsVisible] = useState(false);
  const [modalSalesRegionClassificationIsVisible, setModalSalesRegionClassificationIsVisible] = useState(false);

  const { brands, saveBrandClassifications } = useBrand();

  const showModalProductClassification = () => {
    setModalProductClassificationIsVisible(true);
  };

  const closeModalProductClassification = () => {
    setModalProductClassificationIsVisible(false);
  };

  const showModalSalesRegionClassification = () => {
    setModalSalesRegionClassificationIsVisible(true);
  };

  const closeModalSalesRegionClassification = () => {
    setModalSalesRegionClassificationIsVisible(false);
  };

  const getBrandLogo = (photoUrl: string, brandName: string) => {
    if (photoUrl)
      return (
        <Image
          src={photoUrl}
          width={60}
          style={{ borderRadius: '12px' }}
          preview={false}
          fallback="data:image/png;base64,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"
        />
      );

    return (
      <Avatar style={{ backgroundColor: 'var(--primary-color)', verticalAlign: 'middle' }} size="large">
        {brandName[0]}
      </Avatar>
    );
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'brandId',
      width: '120px',
      align: 'center' as 'center',
      render: (value: any) => <Text>#{value}</Text>,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
        <TableFilters
          inputPlaceholder={'Filtrar pelo Código'}
          inputValue={selectedKeys[0]}
          onChangeInputValue={setSelectedKeys}
          onFilter={confirm}
          onClearFilters={clearFilters}
        />
      ),
      filterIcon: () => <SearchOutlined />,
      onFilter: (value: any, record: any) => {
        return record.brandId ? record.brandId.toString().toLowerCase().includes(value.toLowerCase()) : '';
      },
      sorter: (brand: Brand, nextBrand: Brand) => brand.brandId - nextBrand.brandId,
    },
    {
      title: 'Marca',
      render: (value: any) => (
        <Row align="middle">
          {getBrandLogo(value.brandPhotoUrl, value.brandName)}
          <strong className="ml-3">{value.brandName}</strong>
        </Row>
      ),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
        <TableFilters
          inputPlaceholder={'Filtrar pela Marca'}
          inputValue={selectedKeys[0]}
          onChangeInputValue={setSelectedKeys}
          onFilter={confirm}
          onClearFilters={clearFilters}
        />
      ),
      filterIcon: () => <SearchOutlined />,
      onFilter: (value: any, record: any) => {
        return record.brandName ? record.brandName.toString().toLowerCase().includes(value.toLowerCase()) : '';
      },
      sorter: (brand: Brand, nextBrand: Brand) => brand.brandName.localeCompare(nextBrand.brandName),
    },
    {
      align: 'right' as 'right',
      render: (record: any) => (
        <Dropdown overlay={menu} trigger={['click']}>
          <EllipsisOutlined
            style={{ cursor: 'pointer', fontSize: '24px', fontWeight: 'bolder' }}
            onClick={() => {
              if (record && record.classifications) {
                setProductClassifications(
                  record.classifications.filter(
                    (classification: any) => classification.classificationType === CLASSIFICATION_TYPE_PRODUCT,
                  ),
                );

                setSalesRegionsClassifications(
                  record.classifications.filter(
                    (classification: any) => classification.classificationType === CLASSIFICATION_TYPE_SALES_REGION,
                  ),
                );

                setActualBrandId(record.brandId);
              } else {
                setProductClassifications([]);
                setSalesRegionsClassifications([]);
                setActualBrandId(null);
              }
            }}
          />
        </Dropdown>
      ),
    },
  ];

  const onDeleteProductClassification = (typeCode: number, code: string) => {
    const index = productClassifications.findIndex(
      (classification: any) =>
        classification.typeCode === typeCode &&
        classification.code === code &&
        classification.classificationType === CLASSIFICATION_TYPE_PRODUCT,
    );

    if (index === -1) return;

    setProductClassifications(productClassifications.filter((_, i) => i !== index));
  };

  const onDeleteSalesRegionClassification = (typeCode: number, code: string) => {
    const index = salesRegionsClassifications.findIndex(
      (classification: any) =>
        classification.typeCode === typeCode &&
        classification.code === code &&
        classification.classificationType === CLASSIFICATION_TYPE_SALES_REGION,
    );

    if (index === -1) return;

    setSalesRegionsClassifications(salesRegionsClassifications.filter((_, i) => i !== index));
  };

  const onAddProductClassification = (values: any) => {
    const index = productClassifications.findIndex(
      (classification: any) =>
        classification.typeCode === values.typeCode &&
        classification.code === values.code &&
        classification.classificationType === CLASSIFICATION_TYPE_PRODUCT,
    );

    if (index !== -1) return message.warning('Classificação já existe!');

    const newClassification = {
      typeCode: Number(values.typeCode),
      code: values.code,
      classificationType: CLASSIFICATION_TYPE_PRODUCT,
    };

    setProductClassifications([...productClassifications, newClassification]);
  };

  const onAddSalesRegionsClassification = (values: any) => {
    const index = salesRegionsClassifications.findIndex(
      (classification: any) =>
        classification.typeCode === values.typeCode &&
        classification.code === values.code &&
        classification.classificationType === CLASSIFICATION_TYPE_SALES_REGION,
    );

    if (index !== -1) return message.warning('Classificação já existe!');

    const newClassification = {
      typeCode: Number(values.typeCode),
      code: values.code,
      classificationType: CLASSIFICATION_TYPE_SALES_REGION,
    };

    setSalesRegionsClassifications([...salesRegionsClassifications, newClassification]);
  };

  const onSaveProductClassifications = () => {
    if (!productClassifications.length || !actualBrandId) return;

    saveBrandClassifications(actualBrandId, productClassifications);
  };

  const onSaveSalesRegionsClassifications = () => {
    if (!salesRegionsClassifications.length || !actualBrandId) return;

    saveBrandClassifications(actualBrandId, salesRegionsClassifications);
  };

  useEffect(() => {
    adaptProductClassificationsItemsList();
  }, [productClassifications]);

  const formatItem = (item: any) => {
    return {
      label1: 'Tipo de Classificação',
      item1: item.typeCode,
      label2: 'Classificação',
      item2: item.code,
    };
  };

  const [currentProductClassificationItems, setCurrentProductClassificationItems] = useState<any[]>([]);

  const adaptProductClassificationsItemsList = () => {
    const list = productClassifications.map(formatItem);

    setCurrentProductClassificationItems(list);
  };

  useEffect(() => {
    adaptSalesRegionClassificationsItemsList();
  }, [salesRegionsClassifications]);

  const [currentSalesRegionClassificationItems, setCurrentSalesRegionClassificationItems] = useState<any[]>([]);

  const adaptSalesRegionClassificationsItemsList = () => {
    const list = salesRegionsClassifications.map(formatItem);

    setCurrentSalesRegionClassificationItems(list);
  };

  const menu = (
    <Menu>
      <Menu.Item key="product" onClick={showModalProductClassification}>
        Classes Produto
      </Menu.Item>
      <Menu.Item key="region" onClick={showModalSalesRegionClassification}>
        Classes Região de Venda
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Row className="mt-4">
        <Col span={24}>
          <Table columns={columns} dataSource={brands} scroll={{ x: 800 }} />
        </Col>
      </Row>

      <FullScreenModal
        destroyOnClose={true}
        footer={null}
        forceRender={false}
        visible={modalProductClassificationIsVisible}
        onOk={closeModalProductClassification}
        onCancel={closeModalProductClassification}
        bodyStyle={{ width: '100%' }}
      >
        <DualForm
          title="Produtos"
          loading={false}
          form={<ClassificationForm onAdd={onAddProductClassification} />}
          list={currentProductClassificationItems}
          onDelete={onDeleteProductClassification}
          onSubmit={onSaveProductClassifications}
        />
      </FullScreenModal>

      <FullScreenModal
        destroyOnClose={true}
        footer={null}
        forceRender={false}
        visible={modalSalesRegionClassificationIsVisible}
        onOk={closeModalSalesRegionClassification}
        onCancel={closeModalSalesRegionClassification}
        bodyStyle={{ width: '100%' }}
      >
        <DualForm
          title="Região de Venda"
          loading={false}
          form={<ClassificationForm onAdd={onAddSalesRegionsClassification} />}
          list={currentSalesRegionClassificationItems}
          onDelete={onDeleteSalesRegionClassification}
          onSubmit={onSaveSalesRegionsClassifications}
        />
      </FullScreenModal>
    </>
  );
};

export default BrandsContent;
